export const VSP_SURVEY_INFO = 'VSP_SURVEY_INFO';
export const VSP_SURVEY_INFO_SUCCESS = 'VSP_SURVEY_INFO_SUCCESS';
export const VSP_SURVEY_INFO_ERROR = 'VSP_SURVEY_INFO_ERROR';

export const DTS_SOCKET_DATA= 'DTS_SOCKET_DATA';
export const DAS_SOCKET_DATA = 'DAS_SOCKET_DATA';

export const VSP_SURVEY_LIST = 'VSP_SURVEY_LIST';
export const VSP_SURVEY_LIST_SUCCESS = 'VSP_SURVEY_LIST_SUCCESS';
export const VSP_SURVEY_LIST_ERROR = 'VSP_SURVEY_LIST_ERROR';

export const VSP_SURVEY_CREATE = 'VSP_SURVEY_CREATE';
export const VSP_SURVEY_CREATE_SUCCESS = 'VSP_SURVEY_CREATE_SUCCESS';
export const VSP_SURVEY_CREATE_ERROR = 'VSP_SURVEY_CREATE_ERROR';

export const VSP_SURVEY_DELETE = 'VSP_SURVEY_DELETE';
export const VSP_SURVEY_DELETE_SUCCESS = 'VSP_SURVEY_DELETE_SUCCESS';
export const VSP_SURVEY_DELETE_ERROR = 'VSP_SURVEY_DELETE_ERROR';

export const FIELD_LITHOLOGY_INFO = 'FIELD_LITHOLOGY_INFO';
export const FIELD_LITHOLOGY_INFO_SUCCESS = 'FIELD_LITHOLOGY_INFO_SUCCESS';
export const FIELD_LITHOLOGY_INFO_ERROR = 'FIELD_LITHOLOGY_INFO_ERROR';

export const PLOT_WELL_DATA_INFO = 'PLOT_WELL_DATA_INFO';
export const PLOT_WELL_DATA_INFO_SUCCESS = 'PLOT_WELL_DATA_INFO_SUCCESS';
export const PLOT_WELL_DATA_INFO_ERROR = 'PLOT_WELL_DATA_INFO_ERROR';

export const VSP_SURVEY_DETAILS = 'VSP_SURVEY_DETAILS';
export const VSP_SURVEY_DETAILS_SUCCESS = 'VSP_SURVEY_DETAILS_SUCCESS';
export const VSP_SURVEY_DETAILS_ERROR = 'VSP_SURVEY_DETAILS_ERROR';

export const VSP_INVERSION_LIST = 'VSP_INVERSION_LIST';
export const VSP_INVERSION_LIST_SUCCESS = 'VSP_INVERSION_LIST_SUCCESS';
export const VSP_INVERSION_LIST_ERROR = 'VSP_INVERSION_LIST_ERROR';

export const VSP_INVERSION_PLOT = 'VSP_INVERSION_PLOT';
export const VSP_INVERSION_PLOT_SUCCESS = 'VSP_INVERSION_PLOT_SUCCESS';
export const VSP_INVERSION_PLOT_ERROR = 'VSP_INVERSION_PLOT_ERROR';

